/** Types of prefixes for otel spans */
export enum LOGTYPE {
    LOADING = 'loading',
    VISITPAGE = 'visit-page',
    CLICK = 'click',
}
